import { Map } from 'immutable';
import { createAction, handleActions } from 'redux-actions';
export const actions = {
    REQUEST_ENTITLEMENTS: createAction('GLOBAL/ENTITLEMENTS/REQUEST'),
    SUCCESS: createAction('GLOBAL/ENTITLEMENTS/SUCCESS'),
    ERROR: createAction('GLOBAL/ENTITLEMENTS/ERROR'),
};
export const initialState = Map({
    isProcessing: false,
    data: null,
    error: null,
});
const reducer = handleActions({
    [actions.REQUEST_ENTITLEMENTS]: (state = initialState) => state.set('isProcessing', true),
    [actions.SUCCESS]: (state = initialState, action) => state.set('isProcessing', false).set('data', action.payload),
    [actions.ERROR]: (state = initialState) => state.set('error', true).set('isProcessing', false),
}, initialState);
export default reducer;
